import { updateYarnLockTag } from './lib/updateYarnLockTag';
import { printReport } from './lib/printReport';

export { updateYarnLockTag }
export { printReport }

export default updateYarnLockTag
